"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.accountBridge = void 0;
var errors_1 = require("@ledgerhq/errors");
var bignumber_js_1 = require("bignumber.js");
var ledger_filecoin_1 = __importDefault(require("@zondax/ledger-filecoin"));
var rxjs_1 = require("rxjs");
var jsHelpers_1 = require("../../../bridge/jsHelpers");
var utils_1 = require("./utils/utils");
var api_1 = require("./utils/api");
var account_1 = require("../../../account");
var hw_1 = require("../../../hw");
var serializer_1 = require("./utils/serializer");
var utils_2 = require("../utils");
var logs_1 = require("@ledgerhq/logs");
var addresses_1 = require("./utils/addresses");
var operation_1 = require("../../../operation");
var deviceAccess_1 = require("../../../hw/deviceAccess");
var receive = (0, jsHelpers_1.makeAccountBridgeReceive)();
var createTransaction = function () {
    // log("debug", "[createTransaction] creating base tx");
    return {
        family: "filecoin",
        amount: new bignumber_js_1.BigNumber(0),
        method: 0,
        version: 0,
        nonce: 0,
        gasLimit: new bignumber_js_1.BigNumber(0),
        gasFeeCap: new bignumber_js_1.BigNumber(0),
        gasPremium: new bignumber_js_1.BigNumber(0),
        recipient: "",
        useAllAmount: false
    };
};
var updateTransaction = function (t, patch) {
    // log("debug", "[updateTransaction] patching tx");
    return __assign(__assign({}, t), patch);
};
var getTransactionStatus = function (a, t) { return __awaiter(void 0, void 0, void 0, function () {
    var errors, warnings, balance, address, recipient, useAllAmount, gasPremium, gasFeeCap, gasLimit, amount, estimatedFees, totalSpent;
    return __generator(this, function (_a) {
        errors = {};
        warnings = {};
        balance = a.balance;
        address = (0, utils_1.getAddress)(a).address;
        recipient = t.recipient, useAllAmount = t.useAllAmount, gasPremium = t.gasPremium, gasFeeCap = t.gasFeeCap, gasLimit = t.gasLimit;
        amount = t.amount;
        if (!recipient)
            errors.recipient = new errors_1.RecipientRequired();
        else if (!(0, addresses_1.validateAddress)(recipient).isValid)
            errors.recipient = new errors_1.InvalidAddress();
        else if (!(0, addresses_1.validateAddress)(address).isValid)
            errors.sender = new errors_1.InvalidAddress();
        if (gasFeeCap.eq(0) || gasPremium.eq(0) || gasLimit.eq(0))
            errors.gas = new errors_1.FeeNotLoaded();
        estimatedFees = (0, utils_2.calculateEstimatedFees)(gasFeeCap, gasLimit);
        totalSpent = useAllAmount ? balance : amount.plus(estimatedFees);
        amount = useAllAmount ? balance.minus(estimatedFees) : amount;
        if (amount.lte(0))
            errors.amount = new errors_1.AmountRequired();
        if (totalSpent.gt(a.spendableBalance))
            errors.amount = new errors_1.NotEnoughBalance();
        // log("debug", "[getTransactionStatus] finish fn");
        return [2 /*return*/, {
                errors: errors,
                warnings: warnings,
                estimatedFees: estimatedFees,
                amount: amount,
                totalSpent: totalSpent
            }];
    });
}); };
var estimateMaxSpendable = function (_a) {
    var account = _a.account, parentAccount = _a.parentAccount, transaction = _a.transaction;
    return __awaiter(void 0, void 0, void 0, function () {
        var a, address, balances, balance, recipient, amount, result, gasFeeCap, gasLimit;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    a = (0, account_1.getMainAccount)(account, parentAccount);
                    address = (0, utils_1.getAddress)(a).address;
                    if (!(0, addresses_1.validateAddress)(address).isValid)
                        throw new errors_1.InvalidAddress();
                    return [4 /*yield*/, (0, api_1.fetchBalances)(address)];
                case 1:
                    balances = _b.sent();
                    balance = new bignumber_js_1.BigNumber(balances.spendable_balance);
                    recipient = transaction === null || transaction === void 0 ? void 0 : transaction.recipient;
                    amount = transaction === null || transaction === void 0 ? void 0 : transaction.amount;
                    if (!recipient) return [3 /*break*/, 3];
                    (0, logs_1.log)("debug", "[estimateMaxSpendable] fetching estimated fees to adjust the real max spendable balance");
                    if (!(0, addresses_1.validateAddress)(recipient).isValid)
                        throw new errors_1.InvalidAddress();
                    return [4 /*yield*/, (0, api_1.fetchEstimatedFees)({ to: recipient, from: address })];
                case 2:
                    result = _b.sent();
                    gasFeeCap = new bignumber_js_1.BigNumber(result.gas_fee_cap);
                    gasLimit = new bignumber_js_1.BigNumber(result.gas_limit);
                    balance.minus((0, utils_2.calculateEstimatedFees)(gasFeeCap, gasLimit));
                    _b.label = 3;
                case 3:
                    if (amount)
                        balance.minus(amount);
                    // log("debug", "[estimateMaxSpendable] finish fn");
                    return [2 /*return*/, balance];
            }
        });
    });
};
var prepareTransaction = function (a, t) { return __awaiter(void 0, void 0, void 0, function () {
    var address, recipient, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                address = (0, utils_1.getAddress)(a).address;
                recipient = t.recipient;
                if (!(recipient && address)) return [3 /*break*/, 2];
                if (!((0, addresses_1.validateAddress)(recipient).isValid &&
                    (0, addresses_1.validateAddress)(address).isValid)) return [3 /*break*/, 2];
                return [4 /*yield*/, (0, api_1.fetchEstimatedFees)({ to: recipient, from: address })];
            case 1:
                result = _a.sent();
                t.gasFeeCap = new bignumber_js_1.BigNumber(result.gas_fee_cap);
                t.gasPremium = new bignumber_js_1.BigNumber(result.gas_premium);
                t.gasLimit = new bignumber_js_1.BigNumber(result.gas_limit);
                t.nonce = result.nonce;
                _a.label = 2;
            case 2: 
            // log("debug", "[prepareTransaction] finish fn");
            return [2 /*return*/, t];
        }
    });
}); };
var sync = (0, jsHelpers_1.makeSync)({ getAccountShape: utils_1.getAccountShape });
var broadcast = function (_a) {
    var _b = _a.signedOperation, operation = _b.operation, signature = _b.signature;
    return __awaiter(void 0, void 0, void 0, function () {
        var tx, resp, hash, result;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    tx = (0, utils_1.getTxToBroadcast)(operation, signature);
                    return [4 /*yield*/, (0, api_1.broadcastTx)(tx)];
                case 1:
                    resp = _c.sent();
                    hash = resp.hash;
                    result = (0, operation_1.patchOperationWithHash)(operation, hash);
                    // log("debug", "[broadcast] finish fn");
                    return [2 /*return*/, result];
            }
        });
    });
};
var signOperation = function (_a) {
    var account = _a.account, deviceId = _a.deviceId, transaction = _a.transaction;
    return (0, deviceAccess_1.withDevice)(deviceId)(function (transport) {
        return new rxjs_1.Observable(function (o) {
            function main() {
                return __awaiter(this, void 0, void 0, function () {
                    var recipient, method, version, nonce, gasFeeCap, gasLimit, gasPremium, useAllAmount, amount, accountId, balance, _a, address, derivationPath, filecoin, fee, serializedTx, result, txHash, signature, operation;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                recipient = transaction.recipient, method = transaction.method, version = transaction.version, nonce = transaction.nonce, gasFeeCap = transaction.gasFeeCap, gasLimit = transaction.gasLimit, gasPremium = transaction.gasPremium, useAllAmount = transaction.useAllAmount;
                                amount = transaction.amount;
                                accountId = account.id, balance = account.balance;
                                _a = (0, utils_1.getAddress)(account), address = _a.address, derivationPath = _a.derivationPath;
                                if (!gasFeeCap.gt(0) || !gasLimit.gt(0)) {
                                    (0, logs_1.log)("debug", "signOperation missingData --> gasFeeCap=".concat(gasFeeCap, " gasLimit=").concat(gasLimit));
                                    throw new errors_1.FeeNotLoaded();
                                }
                                filecoin = new ledger_filecoin_1["default"](transport);
                                _b.label = 1;
                            case 1:
                                _b.trys.push([1, , 3, 4]);
                                o.next({
                                    type: "device-signature-requested"
                                });
                                fee = (0, utils_2.calculateEstimatedFees)(gasFeeCap, gasLimit);
                                if (useAllAmount)
                                    amount = balance.minus(fee);
                                transaction = __assign(__assign({}, transaction), { amount: amount });
                                serializedTx = (0, serializer_1.toCBOR)((0, addresses_1.getAddressRaw)(address), (0, addresses_1.getAddressRaw)(recipient), transaction);
                                (0, logs_1.log)("debug", "[signOperation] serialized CBOR tx: [".concat(serializedTx.toString("hex"), "]"));
                                return [4 /*yield*/, filecoin.sign((0, utils_2.getPath)(derivationPath), serializedTx)];
                            case 2:
                                result = _b.sent();
                                (0, utils_2.isError)(result);
                                o.next({
                                    type: "device-signature-granted"
                                });
                                txHash = "";
                                signature = "".concat(result.signature_compact.toString("base64"));
                                operation = {
                                    id: "".concat(accountId, "-").concat(txHash, "-OUT"),
                                    hash: txHash,
                                    type: "OUT",
                                    senders: [address],
                                    recipients: [recipient],
                                    accountId: accountId,
                                    value: amount,
                                    fee: fee,
                                    blockHash: null,
                                    blockHeight: null,
                                    date: new Date(),
                                    extra: {
                                        gasLimit: gasLimit,
                                        gasFeeCap: gasFeeCap,
                                        gasPremium: gasPremium,
                                        method: method,
                                        version: version,
                                        nonce: nonce,
                                        signatureType: 1
                                    }
                                };
                                o.next({
                                    type: "signed",
                                    signedOperation: {
                                        operation: operation,
                                        signature: signature,
                                        expirationDate: null
                                    }
                                });
                                return [3 /*break*/, 4];
                            case 3:
                                (0, hw_1.close)(transport, deviceId);
                                return [7 /*endfinally*/];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            }
            main().then(function () { return o.complete(); }, function (e) { return o.error(e); });
        });
    });
};
exports.accountBridge = {
    createTransaction: createTransaction,
    updateTransaction: updateTransaction,
    prepareTransaction: prepareTransaction,
    getTransactionStatus: getTransactionStatus,
    estimateMaxSpendable: estimateMaxSpendable,
    sync: sync,
    receive: receive,
    broadcast: broadcast,
    signOperation: signOperation
};
//# sourceMappingURL=account.js.map